import { createTheme, alpha } from "@mui/material/styles";

export const createAppTheme = (
  themeMode: "light" | "dark",
  accentColor: { dark: string; light: string }
) =>
  createTheme({
    palette: {
      mode: themeMode,
      primary: {
        main: themeMode === "dark" ? accentColor.dark : accentColor.light,
      },
      secondary: {
        main: themeMode === "dark" ? "#f44336" : "#F01E2C",
      },
      background: {
        default: themeMode === "dark" ? "#121212" : "#f7f7f8",
        paper: themeMode === "dark" ? "#1b1b1e" : "#ffffff",
      },
      text: {
        primary: themeMode === "dark" ? "#E8E8E8" : "#1a1a1a",
        secondary: themeMode === "dark" ? "#B0B0B0" : "#555555",
      },
      divider: themeMode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableElevation: true,
        },
        styleOverrides: {
          root: {
            boxShadow: "none",
            fontSize: "14px",
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: ({theme}) => ({
            "& .MuiInputBase-root": {
              backgroundColor: theme.palette.mode === 'dark' 
                ? 'rgba(0, 0, 0, 0.2)' 
                : 'rgba(255, 255, 255, 0.2)',
              borderRadius: "12px",
              border: `1px solid rgba(255, 255, 255, 0.1)`,
              backdropFilter: 'blur(10px)',
              color: theme.palette.text.primary,
            },
            "& .MuiInputLabel-root": {
              color: theme.palette.text.secondary,
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: 'none'
            },
          }),
        },
      },
      // START: REVISED TABLE STYLES FOR BORDERLESS LOOK
      MuiTableContainer: {
        styleOverrides: {
          root: ({ theme }) => ({
            // Remove the background and border to make the container transparent
            backgroundColor: 'transparent',
            boxShadow: 'none',
            border: 'none',
          })
        }
      },
      MuiTableHead: {
        styleOverrides: {
          root: ({ theme }) => ({
            // Keep a very subtle background for the header row only
            backgroundColor: alpha(theme.palette.text.primary, 0.05),
          })
        }
      },
      MuiTableCell: {
        styleOverrides: {
          root: ({ theme }) => ({
            // Remove the border from all cells
            borderBottom: 'none',
            paddingTop: '12px',
            paddingBottom: '12px',
          }),
          head: ({ theme }) => ({
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontSize: '0.875rem',
          }),
          body: ({ theme }) => ({
            color: theme.palette.text.primary, // Use primary color for body as well for better contrast on glass
            fontSize: '0.875rem'
          })
        }
      }
      // END: REVISED TABLE STYLES
    },
    typography: {
      fontFamily: ["Noto Sans Thai", "sans-serif"].join(","),
      body1: {
        fontSize: "14px",
      },
      body2: {
        fontSize: "12px",
      },
      caption: {
        fontSize: "10px",
      },
    },
  });